import { useNavigate, Navigate, useLocation } from "react-router-dom";
import "../styles/TeacherSubstitutions.css";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  fetchTeacherInfo,
  sendSubstitutions,
} from "../services/pms";
import { useLanguage } from "../context/LanguageContext";
import LoadingScreen from "../components/LoadingScreen";
import DenyAccessPage from "../components/DenyAccessPage";
import WisdomNavbar from "components/navbars/WisdomNabvar";
import { fetchWisdomRelatedSchools, fetchWisdomRelatedTeachers, fetchWisdomSubjects } from "services/wisdom/wisdomData";

function TeacherSubstitutions() {
  const location = useLocation();
  const { language } = useLanguage();
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [substitute, setsubstitute] = useState({});
  const { userInfo } = useAuth();
  const navigate = useNavigate();

  const handleTeacher = (e) => {
    if (e.target.value !== "") {
      setSelectedUser(e.target.value);
    }
  };

  const addSubstitute = (index) => {
    setsubstitute((prev) => ({ ...prev, [index]: !substitute[index] }));
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const [schoolsResponse, subjectsResponse, teachersResponse] =
          await Promise.all([
            fetchWisdomRelatedSchools(),
            fetchWisdomSubjects(),
            fetchWisdomRelatedTeachers(),
          ]);

        setSchools(schoolsResponse);
        setSubjects(subjectsResponse);

        const filteredTeachers = teachersResponse.filter(
          (teacher) => teacher.id !== userInfo.id
        );

        const relatedUsers =
          (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Super Admin")
            ? filteredTeachers.filter(
              (user) =>
                user.employee.organization_id === userInfo.organization_id
            )
            : teachersResponse;

        setTeachers(relatedUsers);
        setFilteredTeachers(relatedUsers);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [userInfo]);

  useEffect(() => {
    const loadTeacherInfo = async () => {
      try {
        const teacherData = {
          id: Number(selectedUserId?.employee?.user_id),
        };
        const response = await fetchTeacherInfo(teacherData);
        setSelectedTeacher(response);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadTeacherInfo();
  }, [selectedUserId]);

  useEffect(() => {
    const filterFilters = () => {
      const filteringSubjects = subjects.filter(subject => subject.organizations.find(org => (userInfo.user_role === "Operations Excellence Lead" || userInfo.user_role === "Super Admin") ? org.id === Number(selectedSchool) : Number(userInfo?.organization_id)));
      const filteringTeachers = teachers.filter(
        teacher =>
          ((userInfo.user_role === "Operations Excellence Lead" || userInfo.user_role === "Super Admin") ? (selectedSchool === "" ||
            teacher.employee.organization_id === Number(selectedSchool)) : (teacher.employee.organization_id === Number(userInfo?.organization_id))) &&
          (selectedSubject === "" ||
            teacher.subjects.some(sub => sub.id === Number(selectedSubject)))
      );
      setFilteredSubjects(filteringSubjects);
      setFilteredTeachers(filteringTeachers);
    };

    filterFilters();
  }, [selectedSchool, selectedSubject, subjects, teachers, userInfo]);

  // Substitutes can be any teacher in the same organization, regardless of subject
  const substituteTeachers = teachers.filter(
    teacher =>
      (userInfo.user_role === "Operations Excellence Lead" || userInfo.user_role === "Super Admin") ? (selectedSchool === "" ||
        teacher.employee.organization_id === Number(selectedSchool)) : (teacher.employee.organization_id === Number(userInfo?.organization_id))
  );

  const submitSubstitutions = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const entries = Array.from(formData.entries());

    const substitutions = [];

    for (let [name, value] of entries) {
      if (name.includes(" ")) {
        const [classId] = name.split(" ");
        substitutions.push({
          substitute_id: Number(selectedUser),
          session_id: parseInt(classId),
          replacement_id: Number(value),
        });
      }
    }
    try {
      await sendSubstitutions(substitutions);
      toast.success("Done");
      navigate("/pms");
    } catch (err) {
      toast.error("Please fill the data");
      // console.error("Error submitting data:", err);
    }
  };

  if (loading) return <LoadingScreen />;
  if (error?.status === 403) return <Navigate to="/login" state={{ from: location }} replace />;
  if (error) return <p>Error: {error.message}</p>;
  if (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Supervisor" && userInfo.user_role !== "Social Worker" && userInfo.user_role !== "Super Admin") return <DenyAccessPage homePage='/pms' />;
  if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
  if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
  if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;

  return (
    <div className="bg-formColor flex justify-center flex-wrap min-h-screen">
      <WisdomNavbar />
      <div className="w-full">
        <h1 className="text-2xl font-bold text-center">{language ? "Teacher Substitution" : "الاحتياطي"}</h1>
      </div>
      {/* School Filter */}
      {userInfo?.organization_id === 13 && <div className="flex flex-col justify-center items-center w-[99%]">
        <label>{language ? "School:" : ":المدرسة"}</label>
        <select id="school" name="school" onChange={e => setSelectedSchool(e.target.value)} >
          <option value="" disabled selected>
            {language ? "Please Select a School" : "الرجاء اختيار مدرسة"}
          </option>
          {schools.map((school) => (
            <option id={school.id} value={school.id} >{school.name}</option>
          ))}
        </select>
      </div>}
      {/* subjects Filter */}
      <div className="flex flex-col justify-center items-center w-[99%]">
        <label>{language ? "Subject:" : ":المادة"}</label>
        <select id="subject" name="subject" onChange={e => setSelectedSubject(e.target.value)} >
          <option value="" disabled selected>
            {language ? "Please Select a Subject" : "الرجاء اختيار المادة"}
          </option>
          {filteredSubjects.map((subject) => (
            <option id={subject.id} value={subject.id} >{subject.name}</option>
          ))}
        </select>
      </div>
      {/* Teachers Filter */}
      <div className="flex flex-col justify-center items-center w-[99%]">
        <label>{language ? "Teacher:" : ":المعلم"}</label>
        <select id="teacher" name="teacher" onChange={e => setSelectedUserId(teachers.find(t => t.employee?.id === Number(e.target.value)))} onClick={handleTeacher}>
          <option value="" disabled selected>
            {language ? "Please Select a Teacher" : "الرجاء اختيار المعلم"}
          </option>
          {filteredTeachers.map((teacher) => (
            <option
              value={teacher.employee?.id}
            >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
          ))}
        </select>
      </div>
      {selectedUser !== null ? (
        <form onSubmit={submitSubstitutions} className="teacherSessions">
          <div className="TSTitle">
            <div className="TSTitleContent">Class</div>
            <div className="TSTitleContent">Stage</div>
            <div className="TSTitleContent">Session 1</div>
            <div className="TSTitleContent">Session 2</div>
            <div className="TSTitleContent">Session 3</div>
            <div className="TSTitleContent">Session 4</div>
            <div className="TSTitleContent">Session 5</div>
            <div className="TSTitleContent">Session 6</div>
            <div className="TSTitleContent">Session 7</div>
            <div className="TSTitleContent">Session 8</div>
            <div className="TSTitleContent">Session 9</div>
            <div className="TSTitleContent">Session 10</div>
          </div>
          {selectedTeacher?.employee?.teacher?.sessions?.map((classes, index) => (
            <div className="TSTitle text-center">
              <div className="TSContent">{classes.class.name}</div>
              <div className="TSContent">{classes.class.stage.name}</div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 1`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 1`)}
                ></input>
                {substitute[`${classes.id} 1`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 1`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 2`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 2`)}
                ></input>
                {substitute[`${classes.id} 2`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 2`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 3`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 3`)}
                ></input>
                {substitute[`${classes.id} 3`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 3`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 4`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 4`)}
                ></input>
                {substitute[`${classes.id} 4`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 4`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 5`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 5`)}
                ></input>
                {substitute[`${classes.id} 5`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 5`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 6`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 6`)}
                ></input>
                {substitute[`${classes.id} 6`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 6`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 7`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 7`)}
                ></input>
                {substitute[`${classes.id} 7`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 7`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 8`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 8`)}
                ></input>
                {substitute[`${classes.id} 8`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 8`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 9`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 9`)}
                ></input>
                {substitute[`${classes.id} 9`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 9`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
              <div className="TSContent">
                <input
                  type="checkbox"
                  id={`${classes.id} 10`}
                  value=""
                  onChange={() => addSubstitute(`${classes.id} 10`)}
                ></input>
                {substitute[`${classes.id} 10`] ? (
                  <select
                    className="TSSelect"
                    id="teacher"
                    name={`${classes.id} 10`}
                  >
                    <option value="" disabled selected>
                      {language
                        ? "Please Select a Teacher"
                        : "الرجاء اختيار المعلم"}
                    </option>
                    {substituteTeachers.map((teacher) => (
                      <option
                        key={teacher.employee?.id}
                        value={teacher.employee?.id}
                      >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
                    ))}
                  </select>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ))}
          <div className="flex justify-center items-center w-full">
            <button className="bg-wisdomOrange hover:bg-wisdomDarkOrange text-white rounded p-2 flex self-center items-center">{language ? "Submit" : "ارسال"}</button>
          </div>
        </form>
      ) : (
        <div className="noTeacher">Please Select a Teacher</div>
      )}
    </div>
  );
}

export default TeacherSubstitutions;
